import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import { APP_DEFAULT_PATH } from 'Config';
import useAuthContext from 'context/useAuthContext';

// types
import { GuardProps } from 'layout/mantis/types/GuardType';

// ==============================|| GUEST GUARD ||============================== //

const GuestGuard = ({ children }: GuardProps) => {
	const { isLoggedIn } = useAuthContext();
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		if (isLoggedIn) {
			if (location?.pathname?.includes('/support/ticket')) {
				navigate('/app/support/tickets', {
					state: {
						from: ''
					},
					replace: true
				});
			} else {
				navigate(location?.state?.from ? location?.state?.from : APP_DEFAULT_PATH, {
					state: {
						from: ''
					},
					replace: true
				});
			}
		}
	}, [isLoggedIn, navigate, location]);

	return children;
};

export default GuestGuard;
